<div class="mt-3">

<!--Footer starts here-->
 <footer class="footer">
  Copyright &copy; {{ currentDate | date: 'yyyy' }} by UST Global Inc.
  </footer> 
<!--Footer Ends here-->
</div>